import { ButtonHTMLAttributes, forwardRef } from 'react'
import { Slot, Slottable } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const buttonVariants = cva(
  [
    'group',
    'rounded-full px-[20px] py-[6px] text-small',
    'transition-colors duration-500 ease-in-out'
  ],
  {
    variants: {
      variant: {
        primary: ['bg-blue-900 text-[#F0F2F5]'],
        secondary: ['border border-blue-900 text-blue-900 bg-transparent']
      }
    },
    defaultVariants: {
      variant: 'primary'
    }
  }
)

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean
  }

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, variant, className, asChild = false, ...props }, ref) => {
    const Component = asChild ? Slot : 'button'

    return (
      <Component
        ref={ref}
        className={cn(buttonVariants({ variant, className }))}
        {...props}
      >
        <Slottable>{children}</Slottable>
      </Component>
    )
  }
)

export default Button
